import general from '../../functions/logic/general'

const establishmentMapper = (data) => {
    let responseMapper = [];
    for (var i = 0; i < data.length; i++) {
        responseMapper[i] = {
            case: data[i].case ?? '',
            comercialName: data[i].comercial_name ?? '',
            establishment: data[i].establishment ?? '',
            id: data[i].id ?? '',
            identification: data[i].identification ?? '',
            name: data[i].name ?? '',
        }
        responseMapper.push();
    }
    return responseMapper;
}

const moduleMapper = (data) => {
    let moduleMapper = [];
    for (var i = 0; i < data.length; i++) {
        moduleMapper[i] = {
            order: data[i].order ?? '',
            businessId: data[i].business_id ?? '',
            url_temp: data[i].url_temp ?? '',
            id: data[i].id ?? '',
            name: data[i].name ?? '',
            icon: data[i].icon ?? '',
            path: data[i].path ?? '',
            controller: data[i].controller ?? '',
        }
        moduleMapper.push();
    }
    return moduleMapper;
}

const menuMapper = (data) => {
    let moduleMapper = [];
    let nameModule = "";
    for (var f = 0; f < data.length; f++) {
        let subModuleMapper = [];
        for (var i = 0; i < data[f].length; i++) {
            if (data[f][i].master_id === null) {
                nameModule = general.deleteCharacters(data[f][i].name);
            } else {
                nameModule = data[f][i].name;
            }
            subModuleMapper[i] = {
                id: data[f][i].id ?? '',
                masterId: data[f][i].master_id ?? 0,
                name: nameModule ?? '',
                icon: data[f][i].icon ?? '',
                path: data[f][i].path ?? '',
                order: data[f][i].order ?? '',
            }
        }
        moduleMapper[f] = subModuleMapper;
    }
    return moduleMapper;
}

const businessMapper = {
    establishmentMapper,
    moduleMapper,
    menuMapper
}

export default businessMapper;
